<template>
  <transition name="fade-transition">
    <v-card>
      <v-card-title style="padding:0.3em 1em 0">
        <h3>{{ oferta.furnizor.nume_furnizor }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = !show">
          <v-icon>{{ !show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-title style="padding: 0 1em 0.3em">
        <div>
          <h4>
            <a v-if="oferta.oferta_pdf.length > 2" :href="ofertaPdfLink">
              {{ oferta.denumire_oferta }}
              <v-icon small color="primary">save_alt</v-icon>
            </a>
          </h4>
          <h4>Valoare factura(lei): {{ parseFloat(oferta.valoare_factura_furnizor_fc) | price }}</h4>
          <h4>Energie regenerabila: {{ oferta.procent_energie_surse_regenerabile }}%
            <img
              v-if="oferta.procent_energie_surse_regenerabile > 0"
              class="green-leaf"
              src="@/assets/leaves-icon.png"
            />
          </h4>
          <h4 v-if="oferta.ultima_instanta !== 1">
            <strong>Diferenta FUI concurential - FUI obligatoriu</strong>:
            <v-icon v-if="diferentaProcentualaFui > 0" color="red">arrow_downward</v-icon>
            <v-icon v-else-if="diferentaProcentualaFui < 0" color="green">arrow_upward</v-icon>
            {{ diferentaProcentualaFui | abs | price }}%
          </h4>
        </div>
      </v-card-title>
      <v-slide-y-transition>
        <v-card-text v-show="show">
          <ul>
            <!--<li><strong>Tip pret</strong>: <span>Pret pentru serviciul universal</span></li>-->
            <!--<li><strong>Tip produs</strong>: <span>Clienti serviciu universal</span></li>-->
            <li><strong>Valabilitatate oferta</strong>: <span>{{ valabilitate | interval }}</span></li>
            <!--<li><strong>Tip pret oferta</strong>: <span>Pret pentru serviciul universal</span></li>-->
            <li><strong>Pret energie (lei/{{ um.um }})</strong>: {{ pretEnergie | price(5) }}</li>
            <li><strong>Valoare componenta fixa (lei/zi)</strong>: {{ oferta.valoare_abonament }}</li>
            <li><strong>Termen de plata</strong>: {{ oferta.termen_plata }}</li>
            <li><strong>Mod transmitere factura</strong>: {{ modTransmitereFactura }}</li>
            <li><strong>Frecventa emitere factura</strong>: {{ frecventaEmitereFactura }}</li>
            <li><strong>Frecventa citire contor</strong>: {{ frecventaCitireContor }}</li>
            <li v-if="oferta.model_contract.length > 4"><strong>Model contract</strong>:
              <a :href="modelContract" target="_blank">Descarca <v-icon small color="primary">save_alt</v-icon></a></li>

            <li><strong>Alte costuri</strong>: {{ oferta.penalitati }}</li>
            <li>
              Structura achizitie energie electrica in anul {{ oferta.an_achizitie_energie }}
              <ul>
                <li v-for="(v, k) in oferta.structura_achizitie">
                  {{ k | ucfirst }}: {{ v }}%
                </li>
              </ul>
            </li>
            <li><strong>Reduceri aplicate</strong>: {{ oferta.reduceri }}</li>
            <li><strong>Perioada de aplicare a reducerii</strong>: {{ perioadaReducere | interval }}</li>
            <li><strong>Servicii aditionale incluse</strong>: {{ oferta.servicii_aditionale_incluse }}</li>
            <li><strong>Tarif transport TL (lei/{{ um.um }})</strong>: {{ tarifTransportTL | price(5) }}</li>
            <li><strong>Tarif serviciu sistem (lei/{{ um.um }})</strong>: {{ tarifServiciuSistem | price(5) }}</li>
            <li><strong>Tarif serviciu distributie (lei/{{ um.um }})</strong>: <span>{{ tarifDistributie | price(5) }}</span></li>
            <li><strong>Contravaloare certificate verzi (lei/{{ um.um }})</strong>: <span>{{ contravaloareCV | price(5) }}</span></li>
            <li><strong>Taxa cogenerare inalta eficienta (lei/{{ um.um }})</strong>: <span>{{ taxaCogenerare | price(5) }}</span></li>
            <li><strong>Acciza (lei/{{ um.um }})</strong>: <span>{{ acciza | price(5) }}</span></li>
            <li><strong>TVA (%)</strong>: <span>{{ tarif.tva }}</span></li>
          </ul>
          <!--<pre style="background-color: #eee; white-space: pre-wrap">{{ oferta }}</pre>-->
        </v-card-text>
      </v-slide-y-transition>
    </v-card>
  </transition>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {makeItems} from '@/modules/electric/form.js';
  import keywords from '@/modules/electric/lang/index.js';
  import {formatDate, isValidDate, ucfirst, site_domain} from "@/modules/common.js";

  export default {
    props: {
      oferta: Object,
      zona: Object,
      tarif: Object,
      um: Object,
      fuiObligator: Number
    },
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapGetters(['language']),
      diferentaProcentualaFui() {
        return (this.oferta.valoare_factura_furnizor_fc - this.fuiObligator) / this.oferta.valoare_factura_furnizor_fc * 100;
      },
      pretEnergie() {
        return this.divPrice(this.oferta.pret_energie);
      },
      acciza() {
        return this.divPrice(this.tarif.acciza);
      },
      taxaCogenerare() {
        return this.divPrice(this.tarif.taxa_cogenerare_inalta_eficienta);
      },
      tarifServiciuSistem() {
        return this.divPrice(this.tarif.tarif_serviciu_sistem);
      },
      tarifTransportTL() {
        return this.divPrice(this.tarif.tarif_transport_tl);
      },
      tarifDistributie() {
        return this.divPrice(this.zona.tarif_distributie);
      },
      contravaloareCV() {
        return this.divPrice(this.oferta.contravaloare_cv);
      },
      modelContract() {
        return site_domain + 'files/' + this.oferta.model_contract;
      },
      ofertaPdfLink() {
        return site_domain + 'files/' + this.oferta.oferta_pdf;
      },
      frecventaEmitereFactura() {
        const found = this.items.frecventeEmitereFacturi.find(m => m.anre_value === this.oferta.frecventa_emitere_factura)
        if (!found) {
          console.log(`Missing value for labels: frecventaEmitereFactura[${this.oferta.frecventa_emitere_factura}]`)
        }
        return found ? found.label : 'n/a'
      },
      modTransmitereFactura() {
        const found = this.items.facturaElectronica.find(m => m.anre_value === this.oferta.mod_transmitere_factura);
        if (!found) {
          console.log(`Missing value for labels: modTransmitereFactura[${this.oferta.mod_transmitere_factura}]`)
        }
        return found ? found.label : 'n/a'
      },
      frecventaCitireContor() {
        const found = this.items.frecventeCitireContor.find(m => m.anre_value === this.oferta.frecventa_citire_contor);
        if (!found) {
          console.log(`Missing value for labels: frecventaCitireContor[${this.oferta.frecventa_citire_contor}]`)
        }
        return found ? found.label : 'n/a'
      },
      items() {
        return makeItems(this.language);
      },
      keywords() {
        return keywords[this.language];
      },
      perioadaReducere() {
        return [
          this.oferta.perioada_reducere_min,
          this.oferta.perioada_reducere_max
        ];
      },
      valabilitate() {
        return [
          this.oferta.data_inceput_oferta,
          this.oferta.data_sfarsit_oferta
        ];
      }
    },
    methods: {
      divPrice(p) {
        return p === undefined ? p : p / this.um.div
      }
    },
    filters: {
      ucfirst,
      abs: v => Math.abs(v)
    }
  }
</script>
<style lang="stylus">
  .green-leaf
    max-height 20px
</style>
